import { useState } from 'react';
import Sidebar from '../../components/Layout/Sidebar';
import ClientService from '../../services/clientService';

export default function RegisterClient() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    address: '',
  });

  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      const response = await ClientService.createClient(formData);
      console.log('Client registered:', response.data);
      setMessage('Client registered successfully!');
      setFormData({ name: '',company: '', email: '', phone: '', address: '' });
    } catch (err) {
      if (err.response && err.response.status === 422) {
        const validationErrors = err.response.data.errors;
        if (validationErrors.email) {
          setError(validationErrors.email[0]);
        } else {
          setError('Validation failed.');
        }
      } else {
        setError('Something went wrong.');
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex">
      <Sidebar />

      <div className="flex-1 md:ml-64 mt-14 md:mt-0 px-4 py-4 md:px-6 md:py-6">
        <div className="max-w-8xl mx-auto mb-6">
          <h1 className="text-3xl font-bold text-white bg-black p-4 rounded shadow text-center">
            Register New Client
          </h1>
        </div>

        <div className="max-w-xl mx-auto bg-white p-6 rounded shadow">
          <h2 className="text-2xl font-bold mb-4">Client Information</h2>

          {/* Message Feedback */}
          {message && <p className="text-green-600 font-semibold mb-4">{message}</p>}
          {error && <p className="text-red-600 font-semibold mb-4">{error}</p>}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-700 font-medium">Client Name</label>
              <input
                type="text"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                className="w-full mt-1 p-2 border border-gray-300 rounded"
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium">Company Name</label>
              <input
                type="text"
                name="company"
                required
                value={formData.company}
                onChange={handleChange}
                className="w-full mt-1 p-2 border border-gray-300 rounded"
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium">Email Address</label>
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full mt-1 p-2 border border-gray-300 rounded"
              />
            </div>

            <div>
              <label className="block text-gray-700 font-medium">Phone Number</label>
              <input
                type="text"
                name="phone"
                required
                value={formData.phone}
                onChange={handleChange}
                className="w-full mt-1 p-2 border border-gray-300 rounded"
              />
            </div>

            <div>
              <label className="block text-gray-700 font-medium">Address (optional)</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                className="w-full mt-1 p-2 border border-gray-300 rounded"
              />
            </div>

            <div>
              <button
                type="submit"
                className="bg-black text-white px-6 py-2 rounded hover:bg-gray-900"
              >
                Register Client
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
